$(function () {
   if (window.scrollY > 122) {
        $('#btnToTop').fadeIn();
        $('#header-fixed').fadeIn('slow');
    }

    window.addEventListener('scroll', function () {
        if (window.scrollY > 122) {
            $('#btnToTop').fadeIn();
            $('#header-fixed').fadeIn('slow');
        } else {
            $('#btnToTop').fadeOut();
            $('#header-fixed').fadeOut();
        }
    });

    $('a[data-target="#about"]').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#about").offset().top - 60
        });
    });

    $('a[data-target="#services"]').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#services").offset().top - 60
        });
    });

    $('a[data-target="#portfolio"]').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#portfolio").offset().top - 60
        });
    });

    $('a[data-target="#contacts"]').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#contacts").offset().top - 60
        });
    });

    $('#btnToTop').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        });
    }); 
});